webpackJsonp([94],{

/***/ 1283:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_messaging_templates_vue__ = __webpack_require__(1930);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f91af2ba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_messaging_templates_vue__ = __webpack_require__(2422);
function injectStyle (ssrContext) {
  __webpack_require__(2420)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f91af2ba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_messaging_templates_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f91af2ba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_messaging_templates_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1930:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'page-messaging-templates'
});

/***/ }),

/***/ 2420:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2421);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1266)("0140951e", content, true, {});

/***/ }),

/***/ 2421:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1265)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroT;src:url(\"/static/fonts/NeuzeitGroT.eot\");src:url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBold;src:url(\"/static/fonts/NeuzeitGroTBold.eot\");src:url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTLig;src:url(\"/static/fonts/NeuzeitGroLig.eot\");src:url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBla;src:url(\"/static/fonts/NeuzeitGroTBla.eot\");src:url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");font-weight:400;font-style:normal}", "", {"version":3,"sources":["/opt/build/repo/src/pages/configuration/page-messaging-templates.vue"],"names":[],"mappings":"AACA,WACE,yBAA4B,AAC5B,0CAA2C,AAC3C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,wBAA2B,AAC3B,yCAA0C,AAC1C,iHAAmH,AACnH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,4BAA+B,AAC/B,6CAA8C,AAC9C,yHAA2H,AAC3H,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,2CAA4C,AAC5C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,4CAA6C,AAC7C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB","file":"page-messaging-templates.vue","sourcesContent":["\n@font-face {\n  font-family: 'Lato_regular';\n  src: url(\"/static/fonts/Lato-Regular.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroT';\n  src: url(\"/static/fonts/NeuzeitGroT.eot\");\n  src: url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBold';\n  src: url(\"/static/fonts/NeuzeitGroTBold.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTLig';\n  src: url(\"/static/fonts/NeuzeitGroLig.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBla';\n  src: url(\"/static/fonts/NeuzeitGroTBla.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2422:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/94.96653ac3e48a28f4eec8.js